import React from 'react'
import PropTypes from 'prop-types'
import { Box, Paper, Typography } from '@material-ui/core'

import useStyles from './styles'

const PhishingStatCard = ({ label, value, subLabel }) => {
  const classes = useStyles()

  return (
    <Box component={Paper} className={classes.root}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={classes.value}>{value}</Typography>
      {subLabel && (
        <Typography className={classes.subLabel}>{subLabel}</Typography>
      )}
    </Box>
  )
}

PhishingStatCard.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  subLabel: PropTypes.string,
}

export default PhishingStatCard
